import { Component, OnDestroy, OnInit } from '@angular/core'
import { SharedServices } from '../../../../services/shared.services'
import { ActivatedRoute, Router } from '@angular/router'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import * as moment from 'moment'
import { notification } from 'onsenui'
import { imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { StateServices } from '../../../../services/state.services'
import {Subscription} from 'rxjs/Subscription'

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './timeline.component.css',
        '../../../../stagingcss/lui-select.component.css'],
    providers: [MatrixServices]
})
export class TimelineComponent implements OnInit, OnDestroy {
    imageUrl = imageUrl
    en = {}
    showEN = true
    idRoom
    arrList
    getUserId
    statusTimeline = true
    statusSetting = false


    listCheckOwner
    listCheckOwnerId
    listCheckarrUsers
    listCheckarrUsersId
    explanation
    title
    url
    faceImage
    arrFace
    statusImage = false
    createDate
    showDate1
    timestampDate
    arrRoomId
    listUser
    arrData = {}
    arrOwners
    arrUsers
    timestampDateDb
    pauseVideo = true
    arrImage = []
    arrImageHash = []
    matrixImage = []
    animationDuration
    arrLoading = false
    statusShowImage = false
    hasBeenEdited = false
    messageTags = []
    msgTagsObject = {}
    activeTag = ''
    visibleTimelineTags = []
    roomTags = []
    selectedTags = []

    enableBehavior: any = 'false'
    isSaveEditRoom = false
    subscription: Subscription

    constructor(private auth: AuthService, private router: Router, private stateServices: StateServices, private activatedRoute: ActivatedRoute, private restApi: RestServices, private _sharedService: SharedServices, public matrixServices: MatrixServices) {
        this.idRoom = activatedRoute.snapshot['params'].id
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.listCommunicationId(this.idRoom)
        this.subscription = _sharedService.changeEmitted$.subscribe(success => {
            if (success && success[0] === 'statusTab') {
                if (success[1] === 1) {
                    this.statusTimeline = true
                    this.statusSetting = false
                    this.activeTag = ''
                    this.filterTags()
                }
                if (success[1] === 2) {
                    this.statusTimeline = false
                    this.statusSetting = true
                    this.getRoomId(this.idRoom)
                }
            }
            if (success === 'saveRoom') {
                this.saveEditRoom(this.idRoom)
            }
            if (success && success[0] === 'loadTimelineNew') {
                const listRoomMessage = success[1]
                this.arrList = listRoomMessage.sort(function(a, b) {
                    return b.postDate - a.postDate
                })
                this.filterTags()
            }
        })

        _sharedService.changeEmittedSource$.subscribe(
            success => {
                if (success[2] === 'arrOwner') {
                    this.listCheckOwner = success[0]
                    this.listCheckOwnerId = success[1]
                    this._sharedService.emitChange('alertCheckRouting')
                }
                if (success[2] === 'arrUsers') {
                    this.listCheckarrUsers = success[0]
                    this.listCheckarrUsersId = success[1]
                    this._sharedService.emitChange('alertCheckRouting')
                }
            })
    }

    ngOnInit() {
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        const arrFlip: any[] = []
        arrFlip.push(jsonFlip)
        this.matrixServices.arrImageHash = [{}]
        this.matrixServices.arrRotate = [0]
        this.matrixServices.arrStyleImage = ['']
        this.matrixServices.arrFlip = arrFlip
        this.matrixServices.dXdYMatrixCanvas = [0]
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    changeActiveTag(item) {
        if (this.activeTag == item) {
            this.activeTag = ''
        } else {
            this.activeTag = item
        }
        this.filterTags()
    }

    // filter timeline by message tag
    filterTags() {
        let result = []
        if (this.activeTag && this.arrList && this.arrList.length > 0) {
            this.arrList.forEach(item => {
                if (item['tags'] && item['tags'].length) {
                    item['tags'].forEach(e => {
                        if (e == this.activeTag) {
                            result.push(item)
                        }
                    })
                }
            })
            this.visibleTimelineTags = result.map(x => Object.assign({}, x))
        } else {
            this.visibleTimelineTags = this.arrList.map(x => Object.assign({}, x))
        }
    }

    // convert array of message tags to object
    convertMsgTagsObject() {
        this.msgTagsObject = this.messageTags.reduce(function(acc, cur, i) {
            acc[cur._id] = cur.title
            return acc
        }, {})
    }

    // list timeline
    listCommunicationId(idRoom) {
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const roomId = {}
        roomId['{"roomId":"' + idRoom + '"}'] = true
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    map,
                },
                roomMessage: {
                    paths: roomId,
                    searches: roomId,
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const listRoomMessage = success['response']['roomMessage']['searches']['{"roomId":"' + idRoom + '"}']
                    this.getUserId = success['response']['staff']['paths']['{}']
                    this.arrList = listRoomMessage.sort(function(a, b) {
                        return b.postDate - a.postDate
                    })
                    this.filterTags()
                    const settingBehavior: any[] = success['response']['setting']['paths']['{}'] ? success['response']['setting']['paths']['{}'] : []
                    const findItem = settingBehavior.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findItem) {
                        if (this.enableBehavior == 'true') {
                            this.messageTags = findItem['roomMessageTag'] ? findItem['roomMessageTag'] : []
                        } else {
                            this.messageTags = []
                        }
                    } else {
                        this.messageTags = []
                    }
                    this.convertMsgTagsObject()
                },
            )
        })
    }

    // add or remove selected tags
    toggleTag(item) {
        this.markChanged()
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
    }

    // check tag is selected
    checkActiveTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            return false
        }
        return true
    }


    onDistry() {
        if (this.title !== undefined || this.faceImage !== undefined || this.explanation !== undefined) {
            this._sharedService.emitChange('alertCheckRouting')
        }
    }

    getOwner() {
        this._sharedService.emitChange('activeOwners')
        this.arrOwners = ['activeOwnersApi', this.listCheckOwnerId]
        this._sharedService.emitChange(this.arrOwners)
    }

    getUsers() {
        this._sharedService.emitChange('activeUsers')
        this.arrUsers = ['activeUsersApi', this.listCheckarrUsersId]
        this._sharedService.emitChange(this.arrUsers)
    }

    markChanged() {
        this._sharedService.emitChange('alertCheckRouting')
    }

    // handleFileInput(files: FileList, event) {
    //     if (event.target.files && event.target.files[0]) {
    //         const reader = new FileReader();
    //
    //         reader.readAsDataURL(event.target.files[0]); // read file as data url
    //
    //         reader.onload = (event: any) => { // called once readAsDataURL is completed
    //             // const json = JSON.stringify(event.target.result);
    //             // const blob = new Blob([json], {type: 'image/jpeg'});
    //             //     this.url = URL.createObjectURL(blob);
    //             this.url = event.target.result;
    //             this.statusImage = true;
    //         };
    //     }
    //     this.auth.authToken().then(tokenReNew => {
    //         this.restApi.postFile(files.item(0), tokenReNew).subscribe(
    //             success => {
    //                 this.faceImage = success['hash'];
    //             }
    //         );
    //     });
    // }

    allowDrop(e) {
        e.preventDefault()
    }

    drop(ev) {
        ev.preventDefault()
        const reader = new FileReader()
        reader.readAsDataURL(ev.dataTransfer.files[0])
        const excrptFile: any = 'image/'
        const tmpFile: any = ev.dataTransfer.files[0]
        const typeFile: String = tmpFile['type']
        this.animationDuration = 2800
        if (typeFile.includes(excrptFile) && ev.dataTransfer.files && ev.dataTransfer.files.length > 0) {
            reader.onload = (event: any) => { // called once readAsDataURL is completed
                // const json = JSON.stringify(event.target.result);
                // const blob = new Blob([json], {type: 'image/jpeg'});
                //     this.url = URL.createObjectURL(blob);
                // this.url = event.target.result;
                this.arrLoading = true
                this.animationDuration = 2800
                this.statusImage = true
                this.statusShowImage = true
                this.arrImageHash = [undefined]
                this.matrixImage = [1, 0, 0, 1]
                this.matrixServices.arrFlip = [{
                    'horizontalFlip': 1,
                    'verticalFlip': 1,
                }]
            }
            this.auth.authToken().then(tokenReNew => {
                this.restApi.postFile(ev.dataTransfer.files.item(0), tokenReNew).subscribe(
                    success => {
                        this.faceImage = success['hash']
                        const idImage = {
                            id: this.faceImage,
                            matrix: [1, 0, 0, 1],
                        }
                        // this.matrixServices.arrImageHash.splice(0, 1, idImage);
                        this.arrImageHash.splice(0, 1, idImage)
                        this.url = imageUrl + success['hash'] + '?type=medium'
                        this.arrImage.splice(0, 1, this.url)
                        this.arrLoading = false
                        this.statusShowImage = false
                    },
                )
            })
        }
    }

    handleFileInput(files: FileList, event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader()
            this.isSaveEditRoom = true
            reader.readAsDataURL(event.target.files[0]) // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                // const json = JSON.stringify(event.target.result);
                // const blob = new Blob([json], {type: 'image/jpeg'});
                //     this.url = URL.createObjectURL(blob);
                // this.url = event.target.result;
                this.arrLoading = true
                this.animationDuration = 2800
                this.statusImage = true
                this.statusShowImage = true
                this.arrImageHash = [undefined]
                this.matrixImage = [1, 0, 0, 1]
                this.matrixServices.arrFlip = [{
                    'horizontalFlip': 1,
                    'verticalFlip': 1,
                }]
            }
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                success => {
                    this.faceImage = success['hash']
                    const idImage = {
                        id: this.faceImage,
                        matrix: [1, 0, 0, 1],
                    }
                    // this.matrixServices.arrImageHash.splice(0, 1, idImage);
                    this.arrImageHash.splice(0, 1, idImage)
                    this.url = imageUrl + success['hash'] + '?type=medium'
                    this.arrImage.splice(0, 1, this.url)
                    this.arrLoading = false
                    this.statusShowImage = false
                    this.isSaveEditRoom = false
                },
            )
        })
    }

    // show theme date
    showDate(event) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event) {
            const setTimestamp = moment(event['_d'])
            setTimestamp.set({ hours: 10 })
            const timestamp = moment(setTimestamp).startOf('day').valueOf()
            this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
            this.timestampDateDb = moment(setTimestamp).utc().startOf('day').valueOf()
            this.createDate = moment(timestamp)
        } else {
            const timestamp = moment(Date.now()).utc().startOf('day').valueOf()
            this.showDate1 = moment(Date.now()).format('YYYY.MM.DD ddd')
            this.timestampDateDb = timestamp
        }
    }

    nextDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').add(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    prevDate(timestampAdd, day) {
        this.markChanged()
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').startOf('day').valueOf()
        const timestampDateDb = moment(adDate['_d']).utc().add(addTime, 'hours').subtract(day, 'days').startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.timestampDateDb = timestampDateDb
        this.showDate1 = showdateAdd
        this.createDate = moment(timestampDate)
    }

    // list timeline
    getRoomId(idRoom) {
        const resourceUrl = 'resource'
        const map = {}
        map[idRoom] = true
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    }
                },
                room: {
                    map,
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    // this.arrImageHash = [undefined];
                    this.arrRoomId = success['response']['room']['map'][idRoom]
                    this.showDate1 = moment(this.arrRoomId['visitDate']).format('YYYY.MM.DD ddd')
                    this.createDate = moment(this.arrRoomId['visitDate'])
                    this.listUser = success['response']['staff']['paths']["{}"]
                    this.listCheckOwnerId = this.arrRoomId['owners']
                    this.listCheckarrUsersId = this.arrRoomId['users']
                    this.title = this.arrRoomId['title']
                    this.explanation = this.arrRoomId['explanation']
                    this.arrImageHash.splice(0, 1, this.arrRoomId['faceImage'])
                    this.url = (this.arrRoomId['faceImage'] ? imageUrl + this.arrRoomId['faceImage']['id'] + '?type=medium' : undefined)
                    this.arrImage.splice(0, 1, this.url)
                    this.matrixImage = (this.arrRoomId['faceImage'] ? this.arrRoomId['faceImage']['matrix'] : [1, 0, 0, 1])
                    const settingBehavior = success['response']['setting']['paths']['{}'] ? success['response']['setting']['paths']['{}'] : []
                    const findItem = settingBehavior.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findItem) {
                        if (this.enableBehavior == 'true') {
                            this.roomTags = findItem['roomTag'] ? findItem['roomTag'] : []
                        } else {
                            this.roomTags = []
                        }
                        this.selectedTags = this.arrRoomId['tags'] ? this.arrRoomId['tags'] : []
                    } else {
                        this.roomTags = []
                        this.selectedTags = []
                    }
                },
            )
        })
    }

    // click show modall timeline
    messageModal(key) {
        if (key === 'video') {
            const arrMessage = [this.idRoom, 'showModalVideo', -1, 'create', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
        if (key === 'message') {
            const arrMessage = [this.idRoom, 'showModalMessage', -1, 'create', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
        if (key === 'image') {
            const arrMessage = [this.idRoom, 'showModalImage', -1, 'create', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
    }

    // click edit modal timeline
    editTimeline(key, id) {
        if (key === undefined) {
            const arrMessage = [this.idRoom, 'showModalMessage', id, 'edit', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
        if (key === 'movie') {
            const arrMessage = [this.idRoom, 'showModalVideo', id, 'edit', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
        if (key === 'image') {
            const arrMessage = [this.idRoom, 'showModalImage', id, 'edit', this.messageTags]
            this._sharedService.emitChange(arrMessage)
        }
    }

    // start animation
    startActivateCard(event) {
        const card = $(event.currentTarget).closest('.card')
        card.addClass('activated')
    }

    stopActivateCard(event) {
        const card = $(event.currentTarget).closest('.card')
        card.removeClass('activated')
    }


    // ************************************************ SETTING *******************************************************//
    alertSaveRoom(idRoom) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-save'],
            title: this.en['alert-save'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.saveEditRoom(idRoom)
                    this._sharedService.emitChange('removestatusRouting')
                }
            },
        })
    }

    saveEditRoom(idRoom) {
        const map = {}
        map[idRoom] = true
        if (this.title !== undefined) {
            this.arrData['title'] = this.title
        }
        if (this.explanation !== undefined) {
            this.arrData['explanation'] = this.explanation
        }
        if (this.arrImageHash && this.arrImageHash[0] !== undefined) {
            this.arrData['faceImage'] = this.arrImageHash[0]
        } else {
            this.arrData['faceImage'] = null
        }
        if (this.listCheckOwnerId !== undefined) {
            this.arrData['owners'] = this.listCheckOwnerId
        }
        if (this.listCheckarrUsersId !== undefined) {
            this.arrData['users'] = this.listCheckarrUsersId
        }
        if (this.timestampDateDb !== undefined) {
            this.arrData['visitDate'] = this.timestampDateDb
        }
        this.arrData['tags'] = this.selectedTags
        const value = this.arrData
        const resourceData = {
            actions: [
                {
                    type: 'update',
                    id: idRoom,
                    collection: 'room',
                    value,
                },
            ],
            status: {
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    map,
                    paths: {
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    this.arrRoomId = success['response']['room']['map'][idRoom]
                    this.arrImageHash.splice(0, 1, this.arrRoomId['faceImage'])
                    this.url = (this.arrRoomId['faceImage'] ? imageUrl + this.arrRoomId['faceImage']['id'] + '?type=medium' : undefined)
                    this.arrImage.splice(0, 1, this.url)
                    this.matrixImage = (this.arrRoomId['faceImage'] ? this.arrRoomId['faceImage']['matrix'] : [1, 0, 0, 1])
                    const passTitle = ['loadTitleSave']
                    this._sharedService.emitChange(passTitle)
                },
            )
        })
    }

    removewRoom(idRoom) {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: this.en['alert-remove'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            modifier: 'rowfooter',
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.deleteRoomId(idRoom)
                    this._sharedService.emitChange('removestatusRouting')
                }
            },
        })
    }

    deleteRoomId(idRoom) {
        const map = {}
        map[idRoom] = true
        const resourceData = {
            actions: [
                {
                    type: 'remove',
                    id: idRoom,
                    collection: 'room',
                },
            ],
            status: {
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    map,
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    return this.router.navigateByUrl('app/main/communication/top')
                },
            )
        })
    }

    pauseVid(event, pause) {
        const video = event.target
        if (pause) {
            video.play()
            this.pauseVideo = false
        } else {
            video.pause()
            this.pauseVideo = true
        }
    }

    showBigImage(id, matrix) {
        event.stopPropagation()
        const arrImage = [id, 'showBigImage', matrix]
        this._sharedService.emitChange(arrImage)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication-room/timeline/timeline.component.ts